import { createStore } from "vuex";
import projects from "./projects/projects.js"
import showDefault from "./showDefault/showDefault.js"
import security from "./security/security.js"
import siteSettings from "./siteSettings/siteSettings.js"



export default createStore({
  modules: { projects, showDefault, security, siteSettings }
});
